<template>
    <PublicProfileLayout>
        <div class="overflow-x-hidden">
            <section class="text-center py-6 px-4 md:px-6 bg-faded">
                <h1 class="LandingPage-Title mb-2">TERMS AND CONDITIONS FOR GENERAL USERS</h1>
                <p class="Label text-500 uppercase tracking-wider">
                    Jurisdiction: Democratic Socialist Republic of Sri Lanka
                </p>
            </section>

            <section class="py-6 px-4 md:px-6 max-w-custom mx-auto">
                <GeneralUserTermsContent />
            </section>

            <section class="text-center py-6 px-4 md:px-6 bg-faded" id="student-terms">
                <h1 class="LandingPage-Title mb-2 uppercase">Terms and Conditions for Students</h1>
                <p class="Label text-500 uppercase tracking-wider">
                    Jurisdiction: Democratic Socialist Republic of Sri Lanka
                </p>
            </section>

            <section class="py-6 px-4 md:px-6 max-w-custom mx-auto">
                <StudentTermsContent />
            </section>

            <section class="text-center py-6 px-4 md:px-6 bg-faded" id="tutor-terms">
                <h1 class="LandingPage-Title mb-2 uppercase">Terms and Conditions for Tutors</h1>
                <p class="Label text-500 uppercase tracking-wider">
                    Jurisdiction: Democratic Socialist Republic of Sri Lanka
                </p>
            </section>

            <section class="py-6 px-4 md:px-6 max-w-custom mx-auto">
                <TutorTermsContent />
            </section>

            <section class="text-center py-6 px-4 md:px-6 bg-faded">
                <h1 class="LandingPage-Title mb-2 uppercase">User Agreement</h1>
                <p class="Label text-500 uppercase tracking-wider">
                    Jurisdiction: Democratic Socialist Republic of Sri Lanka
                </p>
            </section>

            <section class="py-6 px-4 md:px-6 max-w-custom mx-auto" id="user-agreement">
                <UserAgreement />
            </section>
        </div>
    </PublicProfileLayout>
</template>

<script setup>
import PublicProfileLayout from "@/layout/PublicProfileLayout.vue";
import GeneralUserTermsContent from "@/components/legal/GeneralUserTermsContent.vue";
import StudentTermsContent from "@/components/legal/StudentTermsContent.vue";
import TutorTermsContent from "@/components/legal/TutorTermsContent.vue";
import UserAgreement from "@/components/legal/UserAgreement.vue";
</script>

<style scoped>
.LandingPage-Title { color: #1D97BD; }
.bg-faded { background-color: rgba(29, 151, 189, 0.04); }
.max-w-custom { max-width: 900px; }
</style>